import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class FeedbackService {
  readonly rootUrl = AppSettings.webApiURL;
  constructor(public httpClient: HttpClient) { }

  getCustomer() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetListCustomerDDL`);
  }
  getCustomersDDL(accountManager) {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/getCustomersDDL?accountManager=${accountManager == null ? '' : accountManager}`);
  }
  getAccountManagersDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetAccountManagersDDL`);
  }
  getFileName() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFileName`);
  }
  getSUG_HAFRASHA() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetSUG_HAFRASHA`);
  }
  getSUG_KUPA() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetSUG_KUPA`);
  }
  getManagementName() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetManagementName`);
  }
  getMisparMezaeOved() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetMisparMezaeOved`);
  }
  getReport(accountManager,sCustomerId, sFileName, sSugHafrasha, sSugKupa, sManagementName, sMisparMezaheOved, sSelectedStatus, sSelectedUrgent, sRowsLimit, sSelectedErrorCode, reportMonthSelected, chodeshMaskoretSelected, reportNegativeSelected, selectedErrorCodeV4, sSelectedLegalTreatment, resultsTypeSelected) {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetReport?accountManager=${accountManager}&customerId=${sCustomerId}&fileName=${sFileName}&sugHafrasha=${sSugHafrasha}&sugKupa=${sSugKupa}&managementName=${sManagementName}&misparMezaheOved=${sMisparMezaheOved}&selectedStatusId=${sSelectedStatus}&selectedUrgent=${sSelectedUrgent}&selectedErrorCode=${sSelectedErrorCode}&reportMonthSelected=${reportMonthSelected==null?'':reportMonthSelected}&chodeshMaskoretSelected=${chodeshMaskoretSelected==null?'':chodeshMaskoretSelected}&rowsLimit=${sRowsLimit}&reportNegativeSelected=${reportNegativeSelected}&selectedErrorCodeV4=${selectedErrorCodeV4}&selectedLegalTreatment=${sSelectedLegalTreatment}&resultsTypeSelected=${resultsTypeSelected}`);
  }
  setFeedbackAndDeposit(arr: any, statusId: number) {
    return this.httpClient.put(`${this.rootUrl}/api/Feedback/Put?statusValue=${statusId}`, arr);
  }
  getFeedbackStatusDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetListFeedbackStatus`);
  }
  getFeedbackStatisesPrecalculated() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFeedbackStatisesPrecalculated`);
  }
  getFeedbackAccountManager30DaysPrecalculated() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFeedbackAccountManager30DaysPrecalculated`);
  }

  getFeedbackAccountManagerThisMonthPrecalculated() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/getFeedbackAccountManagerThisMonthPrecalculated`);
  }

  downloadFeedbackReport(fileGuid: any) {
    return this.httpClient.get(`${this.rootUrl}/api/Report/Download?fileGuid=${fileGuid}`, { responseType: 'blob' });
  }
  downloadFeedbackReportCsv(fileGuid: any) {
    return this.httpClient.get(`${this.rootUrl}/api/Report/DownloadCsv?fileGuid=${fileGuid}`, { responseType: 'blob' });
  }
  downloadFeedbackReportZip(fileGuid: any) {
    return this.httpClient.get(`${this.rootUrl}/api/Report/DownloadZip?fileGuid=${fileGuid}`, { responseType: 'blob' });
  }
  getFeedbackReport() {
    return this.httpClient.get(`${this.rootUrl}/api/Report/Feedback`);
  }
  getFeedbackErrorCodeDescription(code: any) {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFeedbackErrorCodeDescription?code=${code}`, code);
    //return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFeedbackErrorCodeDescription`);
  }

  GetReportMonthList() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetReportMonthList`);
  }

  GetChodeshMaskoretList() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetChodeshMaskoretList`);
  }

  GetFeedbackErrorCodesV4List() {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFeedbackErrorCodesV4List`);
  }

  GetFeedbackStatusUpdateHistory(MISPAR_MEZAHE_RESHUMA: string) {
    return this.httpClient.get(`${this.rootUrl}/api/Feedback/GetFeedbackStatusUpdateHistory?MISPAR_MEZAHE_RESHUMA=${MISPAR_MEZAHE_RESHUMA}`);
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/feedback.service.ts